/* Cyber Four 2026 · cuenta regresiva y pestañas (secciones cf-*) */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function initCountdown(root) {
    if (root.dataset.cfReady) return;
    root.dataset.cfReady = '1';
    var end = Date.parse(root.getAttribute('data-end'));
    var clock = root.querySelector('[data-cf-clock]');
    var done = root.querySelector('[data-cf-done]');
    if (!clock || isNaN(end)) return;
    var parts = {
      d: clock.querySelector('[data-d]'),
      h: clock.querySelector('[data-h]'),
      m: clock.querySelector('[data-m]'),
      s: clock.querySelector('[data-s]')
    };
    function tick() {
      var diff = Math.max(0, end - Date.now());
      if (diff === 0) {
        clock.hidden = true;
        var label = root.querySelector('[data-cf-label]');
        if (label) label.hidden = true;
        if (done) done.hidden = false;
        return false;
      }
      var s = Math.floor(diff / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400)) + 'd';
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600)) + 'h';
      parts.m.textContent = pad(Math.floor((s % 3600) / 60)) + 'm';
      if (parts.s) parts.s.textContent = pad(s % 60) + 's';
      return true;
    }
    if (tick()) {
      var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000);
    }
  }

  function initTabs(root) {
    if (root.dataset.cfReady) return;
    root.dataset.cfReady = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    }
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab, false); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') next = tabs[0];
        if (e.key === 'End') next = tabs[tabs.length - 1];
        if (next) { e.preventDefault(); select(next, true); }
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-cf-countdown]').forEach(initCountdown);
    (scope || document).querySelectorAll('[data-cf-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // Editor de temas: re-inicializa al agregar o editar secciones
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
